import { render, staticRenderFns } from "./NetaNewMultiEventComponent.vue?vue&type=template&id=579b1cbd&"
import script from "./NetaNewMultiEventComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewMultiEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewMultiEventComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579b1cbd')) {
      api.createRecord('579b1cbd', component.options)
    } else {
      api.reload('579b1cbd', component.options)
    }
    module.hot.accept("./NetaNewMultiEventComponent.vue?vue&type=template&id=579b1cbd&", function () {
      api.rerender('579b1cbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-new/NetaNewMultiEventComponent.vue"
export default component.exports